import { X, CheckCircle, AlertTriangle, Info, AlertCircle } from "lucide-react";

import { useTranslation } from 'react-i18next';
const TOAST_STYLES = {
  success: {
    border: "border-emerald-500/50",
    bg: "bg-emerald-950/30",
    icon: <CheckCircle className="w-4 h-4 text-emerald-400" />,
    titleClass: "text-emerald-300",
  },
  error: {
    border: "border-red-500/50",
    bg: "bg-red-950/30",
    icon: <AlertCircle className="w-4 h-4 text-red-400" />,
    titleClass: "text-red-300",
  },
  warning: {
    border: "border-amber-500/50",
    bg: "bg-amber-950/30",
    icon: <AlertTriangle className="w-4 h-4 text-amber-400" />,
    titleClass: "text-amber-300",
  },
  info: {
    border: "border-sky-500/50",
    bg: "bg-sky-950/30",
    icon: <Info className="w-4 h-4 text-sky-400" />,
    titleClass: "text-sky-300",
  },
};

/**
 * Individual Toast component with type-based styling.
 * Supports: success, error, warning, info
 */
export default function Toast({ id, type = "info", title, description, onClose }) {
  const { t } = useTranslation();
  const style = TOAST_STYLES[type] || TOAST_STYLES.info;

  return (
    <div
      role="alert"
      aria-live="polite"
      className={`
        pointer-events-auto w-full max-w-sm
        border ${style.border} ${style.bg}
        rounded-lg shadow-lg shadow-black/20
        p-4 pr-10
        animate-[toast-slide-in_0.3s_ease-out]
        relative
      `}
    >
      <div className="flex items-start gap-3">
        <div className="shrink-0 mt-0.5" aria-hidden="true">
          {style.icon}
        </div>
        <div className="flex-1 min-w-0">
          {title && (
            <p className={`text-sm font-semibold ${style.titleClass}`}>
              {title}
            </p>
          )}
          {description && (
            <p className="text-xs text-zinc-400 mt-0.5 leading-relaxed">
              {description}
            </p>
          )}
        </div>
      </div>

      {/* Close button */}
      <button
        onClick={() => onClose?.(id)}
        className="absolute top-2 right-2 p-1 rounded text-zinc-500 hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
        aria-label="Dismiss notification"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
